import { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { api } from "@/lib/api";

export default function Weiter() {
  const { id } = useParams();
  const nav = useNavigate();
  useEffect(() => {
    (async () => {
      try {
        const s = await api.get(`/report/${id}/status`).then((r) => r.data);
        if (!s.paid) nav(`/teaser/${id}`, { replace: true });
        else if (!s.details_completed) nav(`/report-erstellen/${id}`, { replace: true });
        else nav(`/report/${id}`, { replace: true });
      } catch (e) {
        nav(`/teaser/${id}`, { replace: true });
      }
    })();
  }, [id]); // eslint-disable-line
  return <div className="min-h-screen flex items-center justify-center"><Loader2 className="h-8 w-8 animate-spin" style={{ color: "#10C98D" }} /></div>;
}
